import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "@/components/ScrollToTop";
import LandingPage from "./pages/LandingPage";
import TurkishLandingPage from "./pages/TurkishLandingPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import Dashboard from "./pages/Dashboard";
import EmbedCode from "./pages/EmbedCode";
import DemoPage from "./pages/DemoPage";
import NotFound from "./pages/NotFound";
import { AuthProvider } from "./lib/context/AuthContext";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import Analytics from './pages/Analytics';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import ContactPage from './pages/ContactPage';
import TurkishContactPage from './pages/TurkishContactPage';
import ContactSuccessPage from './pages/ContactSuccessPage';
import TurkishContactSuccessPage from './pages/TurkishContactSuccessPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <AuthProvider>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/tr" element={<TurkishLandingPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/iletisim" element={<TurkishContactPage />} />
            <Route path="/contact/success" element={<ContactSuccessPage />} />
            <Route path="/iletisim/basari" element={<TurkishContactSuccessPage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/embed" element={
              <ProtectedRoute>
                <EmbedCode />
              </ProtectedRoute>
            } />
            <Route path="/demo-page" element={<DemoPage />} />
            <Route path="/dashboard/analytics" element={
              <ProtectedRoute>
                <Analytics />
              </ProtectedRoute>
            } />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
